<div [class]="alignedDesign() ? 'container-xxl mx-0 pb-4' : 'container-fluid pb-4'">
    <div
        [class]="
            alignedDesign()
                ? 'd-flex flex-wrap justify-content-between align-items-center gap-2 mb-3'
                : ''
        ">
        <p class="text-secondary" [class.mb-0]="alignedDesign()" [class.mb-3]="!alignedDesign()">
            {{ 'savedexport_overview_description' | translate: 'online' : 'export' }}
        </p>

        <div
            class="d-flex flex-wrap justify-content-end align-items-center gap-2"
            [class.mb-3]="!alignedDesign()"
            [class.pe-2]="alignedDesign()">
            @if (deliveryLogEnabled()) {
                <button
                    type="button"
                    class="btn btn-outline-primary d-inline-flex align-items-center gap-2"
                    (click)="openDeliveryLog(null)">
                    <i class="bi bi-clock-history" aria-hidden="true"></i>
                    {{ 'savedexport_deliverylog_open' | translate: 'online' : 'export' }}
                </button>
            }
            <div class="btn-group" role="group">
                <button
                    type="button"
                    class="btn"
                    [class.btn-primary]="viewMode() === 'table'"
                    [class.btn-outline-primary]="viewMode() !== 'table'"
                    [attr.aria-pressed]="viewMode() === 'table'"
                    (click)="setViewMode('table')">
                    <i class="bi bi-list-ul" aria-hidden="true"></i>
                </button>
                <button
                    type="button"
                    class="btn"
                    [class.btn-primary]="viewMode() === 'card'"
                    [class.btn-outline-primary]="viewMode() !== 'card'"
                    [attr.aria-pressed]="viewMode() === 'card'"
                    (click)="setViewMode('card')">
                    <i class="bi bi-grid-3x3-gap" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>

    @if (view(); as view) {
        @if (view.totalCount === 0) {
            <div class="alert alert-web-blue">
                {{ 'savedexport_overview_empty' | translate: 'online' : 'export' }}
            </div>
        } @else if (viewMode() === 'table') {
            <app-saved-exports-table
                [savedExports]="view.savedExports"
                [currentSorting]="sorting()"
                [filterForm]="filterForm"
                [deliveryLog]="deliveryLogEnabled()"
                [alignedDesign]="alignedDesign()"
                [oneLineNames]="longNameLayout()"
                [exportingIds]="exportingIds()"
                [deliveryRequestedIds]="deliveryRequestedIds()"
                (sort)="onSort($event)"
                (filtersReset)="resetFiltersAndSorting()"
                (edit)="editSavedExport($event)"
                (duplicate)="duplicateSavedExport($event)"
                (delete)="deleteSavedExport($event)"
                (export)="exportSavedExport($event)"
                (viewLog)="openDeliveryLog($event)" />
        } @else if (view.savedExports.length === 0) {
            <div class="alert alert-web-blue">
                {{ 'savedexport_overview_no_matches' | translate: 'online' : 'export' }}
            </div>
        } @else {
            <div class="row">
                @for (savedExport of view.savedExports; track savedExport.savedExportId) {
                    <div
                        class="col-sm-12 col-md-6 pb-3"
                        [class.col-lg-3]="!alignedDesign() && !longNameLayout()"
                        [class.col-lg-4]="alignedDesign() || longNameLayout()"
                        [class.col-xl-3]="alignedDesign() && !longNameLayout()">
                        <app-saved-export-card
                            [savedExport]="savedExport"
                            [deliveryLog]="deliveryLogEnabled()"
                            [oneLineName]="longNameLayout()"
                            [exporting]="exportingIds().has(savedExport.savedExportId)"
                            [deliveryRequested]="
                                deliveryRequestedIds().has(savedExport.savedExportId)
                            "
                            (edit)="editSavedExport($event)"
                            (duplicate)="duplicateSavedExport($event)"
                            (delete)="deleteSavedExport($event)"
                            (export)="exportSavedExport($event)"
                            (viewLog)="openDeliveryLog($event)" />
                    </div>
                }
            </div>
        }
    } @else {
        <app-load fadeSpeed="FAST" />
    }
</div>
